<template>
  <div
    :data-bv-show="componentType"
    :data-bv-product-id="productId"
    :data-ui="componentType"
  />
</template>

<script>
export default {
  name: 'BazaarVoiceComponent',
  props: {
    componentType: {
      type: String,
      required: true,
    },
    sessionData: {
      type: Object,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
  },
};
</script>
